import React from 'react';
import './Posts.css';

const Posts = () => {
  const posts = [
    {
      id: 1,
      author: 'Robin Brooks',
      handle: '@robin_j_brooks',
      avatar: 'https://unavatar.io/twitter/robin_j_brooks',
      content: "Gold is up 25% this year. That's the best start to a year since 1980. Central banks are buying at record pace. The world is de-dollarizing and gold is the beneficiary. This is just the beginning.",
      date: 'Jan 2026',
      likes: '12.4K',
      retweets: '3.2K',
      source: 'x.com',
      verified: true
    },
    {
      id: 2,
      author: 'Brew Markets',
      handle: '@brewmarkets',
      avatar: 'https://unavatar.io/twitter/brewmarkets',
      content: 'GOLD JUST HIT ANOTHER ALL-TIME HIGH 🚀\n\nGold is now up 30% over the past year.\n\nFor context, S&P 500 is up 23%.\n\nGold is beating stocks. Let that sink in.',
      date: 'Jan 2026',
      likes: '8.9K',
      retweets: '2.1K',
      source: 'x.com',
      verified: true
    },
    {
      id: 3,
      author: 'Rashad Hajiyev',
      handle: '@hajiyev_rashad',
      avatar: 'https://unavatar.io/twitter/hajiyev_rashad',
      content: 'Gold has outperformed:\n• Nasdaq over 25 years\n• S&P 500 over 25 years\n• Real Estate over 25 years\n• Bonds over 50 years\n\nThe ultimate store of value. Period.',
      date: 'Jan 2026',
      likes: '15.2K',
      retweets: '4.8K',
      source: 'x.com',
      verified: true
    },
    {
      id: 4,
      author: 'Peter Schiff',
      handle: '@PeterSchiff',
      avatar: 'https://unavatar.io/twitter/PeterSchiff',
      content: 'I\'ve been saying it for years: Gold is going to $5,000. Everyone laughed. Now gold is at $4,983 and climbing. Who\'s laughing now? The gold bull market is just getting started.',
      date: 'Jan 2026',
      likes: '22.1K',
      retweets: '6.3K',
      source: 'x.com',
      verified: true
    },
    {
      id: 5,
      author: 'Wall Street Silver',
      handle: '@WallStreetSilv',
      avatar: 'https://unavatar.io/twitter/WallStreetSilv',
      content: '🚨 BREAKING: China just reported adding another 30 tons of gold to their reserves.\n\nThis is the 18th consecutive month of buying.\n\nThey know what\'s coming. Do you?',
      date: 'Jan 2026',
      likes: '18.7K',
      retweets: '5.9K',
      source: 'x.com',
      verified: true
    },
    {
      id: 6,
      author: 'Gold Telegraph',
      handle: '@GoldTelegraph_',
      avatar: 'https://unavatar.io/twitter/GoldTelegraph_',
      content: 'The gold-to-S&P ratio is breaking out.\n\nThis historically signals a MAJOR shift from risk assets to safe havens.\n\nLast time this happened? 2000-2011 gold went from $250 to $1,900.\n\nHistory doesn\'t repeat but it rhymes.',
      date: 'Jan 2026',
      likes: '9.3K',
      retweets: '2.8K',
      source: 'x.com',
      verified: true
    },
    {
      id: 7,
      author: 'Macro Alf',
      handle: '@MacroAlf',
      avatar: 'https://unavatar.io/twitter/MacroAlf',
      content: 'Real yields are crashing.\nFiscal deficits are exploding.\nGeopolitical tensions are rising.\nDe-dollarization is accelerating.\n\nAnd people are asking why gold is rallying?\n\nThe real question is: why isn\'t it higher?',
      date: 'Jan 2026',
      likes: '14.5K',
      retweets: '4.1K',
      source: 'x.com',
      verified: true
    },
    {
      id: 8,
      author: 'Jim Rickards',
      handle: '@JamesGRickards',
      avatar: 'https://unavatar.io/twitter/JamesGRickards',
      content: 'The IMF just issued a warning about global debt levels.\n\nTotal global debt: $315 TRILLION\n\nThere\'s only one way out: currency debasement.\n\nAnd there\'s only one asset that can\'t be printed: GOLD.',
      date: 'Jan 2026',
      likes: '11.2K',
      retweets: '3.7K',
      source: 'x.com',
      verified: true
    },
    {
      id: 9,
      author: 'Sven Henrich',
      handle: '@NorthmanTrader',
      avatar: 'https://unavatar.io/twitter/NorthmanTrader',
      content: 'Gold vs Everything (2024-2025):\n\n✅ Gold +45%\n❌ Bitcoin +38%\n❌ S&P 500 +28%\n❌ Nasdaq +31%\n❌ Bonds -2%\n\nThe barbarous relic is eating everything.',
      date: 'Jan 2026',
      likes: '19.8K',
      retweets: '5.4K',
      source: 'x.com',
      verified: true
    },
    {
      id: 10,
      author: 'Otavio Costa',
      handle: '@TasoBueno',
      avatar: 'https://unavatar.io/twitter/TasoBueno',
      content: 'Gold mining stocks are trading at the cheapest valuations relative to gold in 80 YEARS.\n\nWhen this trade reverses, the moves will be violent.\n\nBut first, gold needs to keep running. And it will.',
      date: 'Jan 2026',
      likes: '7.6K',
      retweets: '2.3K',
      source: 'x.com',
      verified: true
    },
    {
      id: 11,
      author: 'Luke Gromen',
      handle: '@LukeGromen',
      avatar: 'https://unavatar.io/twitter/LukeGromen',
      content: 'The US is paying more in interest on its debt than on defense.\n\nThis is not sustainable.\n\nThe only way out is to devalue the dollar.\n\nGold knows this. That\'s why it\'s at all-time highs.',
      date: 'Jan 2026',
      likes: '16.3K',
      retweets: '4.9K',
      source: 'x.com',
      verified: true
    },
    {
      id: 12,
      author: 'Brent Johnson',
      handle: '@SantiagoAuFund',
      avatar: 'https://unavatar.io/twitter/SantiagoAuFund',
      content: 'Everyone asks about my dollar milkshake theory.\n\nHere\'s the thing: even in that scenario, gold wins.\n\nIn a world of competitive devaluations, gold is the only neutral reserve asset.\n\nOwn gold. Sleep well.',
      date: 'Jan 2026',
      likes: '13.1K',
      retweets: '3.5K',
      source: 'x.com',
      verified: true
    }
  ];

  return (
    <section className="posts" id="posts">
      <div className="container">
        <h2 className="section-title">
          <span className="gold-text">The Golden Sentiment</span>
        </h2>
        <p className="posts-subtitle">
          The smartest minds in finance are all saying the same thing: <span className="gold-text">Gold is going higher.</span>
        </p>

        <div className="posts-grid">
          {posts.map((post) => (
            <div className="post-card" key={post.id}>
              <div className="post-header">
                <img className="post-avatar" src={post.avatar} alt={post.author} onError={(e) => { e.target.onerror = null; e.target.src = post.avatarFallback || 'https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png'; }} />
                <div className="post-author-info">
                  <span className="post-author">
                    {post.author}
                    {post.verified && <span className="verified">✓</span>}
                  </span>
                  <span className="post-handle">{post.handle}</span>
                </div>
                <span className="post-logo">𝕏</span>
              </div>
              <div className="post-content">
                {post.content.split('\n').map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
              <div className="post-footer">
                <span className="post-date">{post.date}</span>
                <div className="post-stats">
                  <span>❤️ {post.likes}</span>
                  <span>🔁 {post.retweets}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="posts-cta">
          <p>Join the golden revolution. Be part of history.</p>
          <button className="btn-primary">Buy $GOLD Now</button>
        </div>
      </div>
    </section>
  );
};

export default Posts;
